export interface ISchedulerMainDesyncDetectInput {
  queueLength: number
  visibleFrameId: string | null
  notifiedFrameId: string | null
  /** Presentation / VBuffer plan index; omit when unknown. */
  presentationNotifiedIdx?: number
  /** Worker `lastNotifiedFrameIdx`; omit when unknown. */
  workerNotifiedIdx?: number
  suppressBecauseRegistrationResync: boolean
  suppressBecauseRegistrationTransitionHold: boolean
}

export interface ISchedulerMainDesyncStatus {
  suspected: boolean
}

/**
 * Flag when the painted creative ≠ presentation authority identity, or when the worker on-air
 * index and presentation index disagree (wrap/commit desync; #1489).
 */
export function detectSchedulerMainDesync(input: ISchedulerMainDesyncDetectInput): ISchedulerMainDesyncStatus {
  const {
    queueLength,
    visibleFrameId,
    notifiedFrameId,
    presentationNotifiedIdx,
    workerNotifiedIdx,
    suppressBecauseRegistrationResync,
    suppressBecauseRegistrationTransitionHold
  } = input

  if (
    queueLength < 1
    || suppressBecauseRegistrationResync
    || suppressBecauseRegistrationTransitionHold
  ) {
    return { suspected: false }
  }

  if (
    presentationNotifiedIdx != null
    && workerNotifiedIdx != null
    && presentationNotifiedIdx >= 0
    && workerNotifiedIdx >= 0
    && presentationNotifiedIdx !== workerNotifiedIdx
  ) {
    return { suspected: true }
  }

  if (
    visibleFrameId == null
    || visibleFrameId === ''
    || notifiedFrameId == null
    || notifiedFrameId === ''
  ) {
    return { suspected: false }
  }

  return { suspected: visibleFrameId !== notifiedFrameId }
}
